module.exports = __webpack_public_path__ + "assets/img/quote.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/quote.png
// module id = 703
// module chunks = 0